import { Div } from '@tblabs/truffle';
import { BlinkMode } from './BlinkMode';


export class Led extends Div
{
    public static Name = "Led";

    public static Green = "#00e100";
    public static Yellow = "#ffc107";
    public static Red = "#f44336";
    public static White = "#fff";
    public static Blue = "#007bff";
    public static Gray = "#c8c8c8";
    public static Black = "#000";
    public static Brown = "#8b4513";
    public static Purple = "#9c27b0";
    public static Pink = "#e91e63";
    public static Orange = "#ff9800";

    private previousColor: string = Led.White;
    private currentColor: string = Led.White;
    private blinkTimer: NodeJS.Timeout | null = null;
    private lightUpTimer: NodeJS.Timeout | null = null;

    private LightUpShadow(color: string)
    {
        this.Style(`box-shadow: 0 0 6px 2px ${color}`);
    }
    private NoShadow(color: string)
    {
        this.Style(`box-shadow: 0 0 2px 1px ${color}`);
    }

    constructor(color: string = Led.White)
    {
        super("led");

        this.SetColor(color);
        this.NoShadow(color);
    }

    public SetColor(color: string): this
    {
        this.previousColor = this.currentColor;
        this.currentColor = color;

        this.Background(color);

        if (color == Led.White)
            this.Style("border: 1px solid #d8d8d8");

        else
            this.Style("border: none");

        return this;
    }

    public PreviousColor(): this
    {
        this.SetColor(this.previousColor);

        return this;
    }

    public LightUp(color: string = this.currentColor, duration: number = 500): this
    {
        this.SetColor(color);

        this.LightUpShadow(color);

        this.lightUpTimer && clearTimeout(this.lightUpTimer);

        if (duration > 0)
        {
            this.lightUpTimer = setTimeout(() => this.NoShadow(color), duration);
        }

        return this;
    }

    public Blink(color: string = this.currentColor, interval: number = 1000, mode: BlinkMode = BlinkMode.Blink): this
    {
        this.SetColor(color);

        let counter = 0;

        this.blinkTimer && clearInterval(this.blinkTimer);

        if (interval > 0)
        {
            this.blinkTimer = setInterval(() =>
            {
                if (counter = 1 - counter)
                {
                    switch (mode)
                    {
                        case BlinkMode.Blink:
                            this.SetColor(color);
                            this.NoShadow(color);
                            break;
                        case BlinkMode.LightUp:
                            this.LightUpShadow(color);
                            break;
                        case BlinkMode.Both:
                            this.SetColor(color);
                            this.LightUpShadow(color);
                            break;
                    }
                }

                else
                {
                    switch (mode)
                    {
                        case BlinkMode.Blink:
                            this.SetColor(Led.White);
                            this.NoShadow(Led.White);
                            break;
                        case BlinkMode.LightUp:
                            this.NoShadow(color);
                            break;
                        case BlinkMode.Both:
                            this.SetColor(Led.White);
                            this.NoShadow(Led.White);
                            break;
                    }
                }
            }, interval);
        }

        return this;
    }

    public Destroy()
    {
        this.blinkTimer && clearInterval(this.blinkTimer);
        this.lightUpTimer && clearInterval(this.lightUpTimer);
    }
}
